import AuthLayoutComponent from '../../features/ui/auth-layout/auth-layout';
import { RegisterForm } from '@old/features/public/register/register-form';

export function NeraRegisterPage() {
  return (
    <AuthLayoutComponent variant="nera">
      <RegisterForm referralSource="nera" />
    </AuthLayoutComponent>
  );
}
